import { BASE_URL } from "./auth";

export async function verifyOtp(email: string, otp: string) {
  const response = await fetch(
    `${BASE_URL}/auth/email-code/verify?email=${email}&code=${otp}&format=microsoft`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response;
}
